<template>
  <div
    class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-3 ts-space-y-3"
  >
    <div>
      <label>{{ $t('saleContract.desposit') }}</label>
      <input
        v-model.number="model.deposit_amount"
        type="number"
        @input="despositInput"
        class="form-control"
      />
      <div class="validate" v-if="errors.has('deposit_amount')">
        {{ errors.first('deposit_amount') }}
      </div>
    </div>
    <div class="ts-grid ts-grid-cols-2 ts-gap-3">
      <div>
        <label :class="model.deposit_amount > 0 ? 'required' : ''">{{
          $t('saleContract.paymentMethod')
        }}</label>
        <a-select
          v-model.number="model.payment_method_id"
          :options="paymentMethod"
          class="ts-w-full"
          @change="fetchBank"
        ></a-select>
        <div class="validate" v-if="errors.has('payment_method_id')">
          {{ errors.first('payment_method_id') }}
        </div>
      </div>
      <div>
        <label class="required">{{ $t('wholesale.bankName') }}</label>
        <a-select
          v-model.number="model.bank_name"
          :options="bankNameOptions"
          @change="bankNameChange"
          :disabled="!isShow([2, 3, 4])"
          class="ts-w-full"
        ></a-select>
        <div class="validate" v-if="errors.has('bank_name')">
          {{ errors.first('bank_name') }}
        </div>
      </div>
    </div>
    <div class="ts-grid ts-grid-cols-2 ts-gap-3">
      <div>
        <label class="required">{{ $t('wholesale.accountNumber') }}</label>
        <a-select
          v-if="!isShow([2])"
          v-model="model.account_number"
          :options="accountOptions"
          @change="accountChange"
          class="ts-w-full"
          :disabled="notDisableFor([3, 4])"
        ></a-select>
        <input type="text" class="form-control" v-if="isShow([2])" />
        <div class="validate" v-if="errors.has('account_number')">
          {{ errors.first('account_number') }}
        </div>
      </div>
      <div>
        <label class="required">{{ $t('wholesale.accountName') }}</label>
        <input
          v-model="model.account_name"
          type="text"
          class="form-control"
          :readonly="isShow([1])"
        />
        <div class="validate" v-if="errors.has('account_name')">
          {{ errors.first('account_name') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
export default {
  name: 'despositPayment',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      bankProfiles: [],
      model: {},
      paymentMethod: [
        {
          value: 1,
          label: 'Cash'
        },
        {
          value: 2,
          label: 'Cheque'
        },
        {
          value: 3,
          label: 'Bank Transfer'
        },
        {
          value: 4,
          label: 'Credit Card'
        }
      ]
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    isShow: vm => arrayValue => {
      return _.includes(arrayValue, vm.model.payment_method_id)
    },
    notDisableFor: vm => arrayValue => {
      return !_.includes(arrayValue, vm.model.payment_method_id)
    },
    bankNameOptions() {
      return this.bankProfiles.map(el => ({
        value: el.bank_name,
        label: el.bank_name
      }))
    },
    accountOptions() {
      let acc = this.bankProfiles.filter(
        b => b.bank_name == this.model.bank_name
      )[0]
      if (acc) {
        return acc.accounts.map(el => ({
          value: el.account_number,
          label: el.account_number,
          name: el.account_name
        }))
      }
      return []
    }
  },
  methods: {
    ...mapActions('wholesale/saleContract', ['getFormViewData']),
    despositInput() {
      this.$emit('calculate')
    },
    fetchBank() {
      if (this.model.payment_method_id == 3) {
        this.$emit('loading', true)
        this.getFormViewData({
          index: 'bankProfile',
          params: {
            fnName: 'bankProfile'
          }
        })
          .then(response => {
            this.bankProfiles = response.data['bankProfile']
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.$emit('loading', false)
          })
      } else {
        this.model.bank_name = null
        this.model.account_number = null
        this.model.account_name = null
      }
    },
    bankNameChange() {
      this.model.account_number = null
      this.model.account_name = null
    },
    accountChange(value, opt) {
      this.model.account_name = opt.data.props.name
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
